<template>
    <div class="switcher-container" @click="openMenu" tabindex="0" @focus="openMenu" @blur="onMenuBlur($event)">
        <i class="locale-icon fa fa-globe"></i>
        <div class="locale-small">{{ getLocaleDisplay(selectedLocale) }}</div>
        <ul class="locale-menu" :class="{'menu-visible': menuOpen}" ref="menu">
            <li class="menu-entry"
                v-for="locale of availableLocales"
                :key="locale"
                tabindex="0"
                @click="selectLocale(locale, true, $event)"
                @keyup.space.prevent="selectLocale(locale)"
                @keyup.enter.prevent="selectLocale(locale)"
                @blur="onMenuBlur($event)">
                {{ getLocaleDisplay(locale) }} - {{ getLocaleFull(locale) }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'locale-switcher',
    data() {
        return {
            availableLocales: [ 'de', 'en', 'es', 'fr', 'sk', 'sl' ],
            menuOpen: false,
        };
    },
    watch: {
        selectedLocale(locale) {
            localStorage.setItem('md_locale', locale);
        },
    },
    computed: {
        selectedLocale() {
            return this.$root.$i18n.locale;
        },
    },
    methods: {
        getLocaleDisplay(locale) {
            const locales = {
                de: 'DE',
                en: 'EN',
                es: 'ES',
                fr: 'FR',
                sk: 'SK',
                sl: 'SL',
            };
            return locales[locale] || locale;
        },
        getLocaleFull(locale) {
            const locales = {
                de: 'Deutsch',
                en: 'English',
                es: 'Español',
                fr: 'Français',
                sk: 'Slovenčina',
                sl: 'Slovenščina',
            };
            return locales[locale] || locale;
        },
        openMenu() {
            const clientRect = this.$el.getBoundingClientRect();
            this.$refs.menu.style.left = clientRect.left + 'px';
            this.$refs.menu.style.top = clientRect.bottom + 'px';
            this.menuOpen = true;
        },
        onMenuBlur(event) {
            if (event.relatedTarget && event.relatedTarget.parentElement === this.$refs.menu) return;
            this.menuOpen = false;
        },
        /**
         * @param locale {string}
         * @param closeMenu {boolean}
         * @param event {MouseEvent|KeyboardEvent} used to cancel propagation which would trigger onMenuBlur
         */
        selectLocale(locale, closeMenu = false, event = null) {
            this.$root.$i18n.locale = locale;
            if (closeMenu) this.menuOpen = false;
            if (event) event.stopPropagation();
        },
    },
}
</script>

<style scoped>
.switcher-container {
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.switcher-container:hover .locale-icon, .switcher-container:focus .locale-icon {
    color: var(--contrast-4)
}

.locale-icon {
    background-color: transparent;
    font-size: 20px;
    margin: auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: color 200ms linear;
    color: var(--color-button);
    cursor: pointer;
}

.locale-small {
    position: absolute;
    bottom: -0.25rem;
    right: -0.5rem;
    font: 10pt 'DistrictProBold';
    color: var(--contrast-4);
    text-shadow: -1px 0 0 var(--menu-bar), 0 -1px 0 var(--menu-bar), 1px 0 0 var(--menu-bar), 0 1px 0 var(--menu-bar);
    cursor: pointer;
}

.locale-menu {
    list-style: none;
    display: none;
    flex-direction: column;
    position: fixed;
    background-color: var(--contrast-1);
    color: var(--contrast-4);
    margin: 0.5rem 0 0 -0.5rem;
    z-index: 1;
}

.locale-menu.menu-visible {
    display: flex;
    align-items: flex-start;
}

.menu-entry {
    padding: 0.35rem 0.7rem;
    font-size: 1rem;
}

.menu-entry:focus {
    background-color: var(--contrast-2);
}

</style>
